export class FeatureFlags {
  static readonly NUVO_2026_R1_LOGO_TOGGLE = 'nuvo-2026-r1-logo-toggle';

  private readonly features: Record<string, boolean>;

  constructor(features?: Record<string, boolean>) {
    this.features = features ?? {};
  }

  get(key: string): boolean {
    return this.features[key] ?? false;
  }

  isNuvo2026R1LogoEnabled(): boolean {
    if (!this.features || Object.keys(this.features).length === 0) {
      return true;
    }
    return this.get(FeatureFlags.NUVO_2026_R1_LOGO_TOGGLE);
  }
}

